var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bottom-submenu",class:_vm.menuClicked == 'catalog' ? 'active' : ''},[_c('BottomMenuCatalog')],1),_c('div',{staticClass:"bottom-submenu",class:_vm.menuClicked == 'cabinet' ? 'active' : ''},[_c('BottomMenuCabinet')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }